import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { QueryParamsModel } from "../_models/query-params";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  templateUrl: "brothers.component.html",
})
export class BrothersComponent implements OnInit {
  public model: any = {};
  public currentUser: any;
  public loading = false;
  public messages: any;
  public brothers: any;
  public activePanel: any;
  public suggestChildrenIds: number[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!this.currentUser) {
      this.router.navigate(["/login"]).then();
    }
  }

  public setSuggestChildrenIds(brothers: any) {
    const finalArr = [];
    const lastName = this.route.snapshot.queryParams[QueryParamsModel.LastName];

    if (!lastName || !brothers.suggestion.children) {
      return;
    }
    const childrenArr: Array<{ childName: string; childId: number }> =
      Object.values(brothers.suggestion.children);
    this.suggestChildrenIds = childrenArr
      .filter((c) => c.childName && c.childName.includes(lastName))
      .map((c) => c.childId);
  }

  public load() {
    this.loading = true;
    this.brothers = undefined;
    this.dataService.getBrothers().subscribe(
      (data) => {
        if (data.suggestion) {
          this.activePanel = "suggestionPanel";
        } else if (data.approved) {
          this.activePanel = "approvedPanel";
        }
        this.loading = false;
        this.brothers = data;
        this.setSuggestChildrenIds(this.brothers);
      },
      (error) => {
        let body = error.json && error.json();
        this.alertService.error(
          body && body.statusText
            ? this.messages[body.statusText]
              ? this.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || error
        );
        this.loading = false;
      }
    );
  }

  public ngOnInit() {
    this.load();
  }
}



// WEBPACK FOOTER //
// ./src/app/brothers/brothers.component.ts